module.exports = __webpack_public_path__ + "img/icon-processing.e6d26a1c.svg";